.card {
    background-color: var(--static-background-strong);
    border-radius: 0.75rem;
    border: 1px solid var(--static-divider-standard);
    padding: 1rem;
    height: fit-content;
    width: 40%;
    max-width: 500px;
    /* width: 100%; */
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }
  
  .title {
    font-size: var(--fs-small-heading);
    font-weight: 500;
    margin: 0;
    color: var(--static-text-strong);
  }
  
  .editButton {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: var(--fs-small);
  }
  
  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .row {
    display: flex;
    align-items: flex-start;
  }
  
  .label {
    width: 7.5rem;
    font-weight: 500;
    color: var(--static-text-strong);
    font-size: var(--fs-small);
    flex-shrink: 0;
  }
  
  .value {
    color: var(--static-text-standard);
    font-size: var(--fs-small);
    flex: 1;
  }
  
  .cardInfo {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border: 1px solid var(--static-text-inverse-standard);
    border-radius: 8px;
    padding: 0.25rem 0.5rem;
    width: fit-content;
  }
  
  .cardInfo svg {
    height: 1.25rem;
    width: auto;
  }
  
  @media (max-width: 640px) {
    .row {
      flex-direction: column;
      gap: 0.25rem;
    }
    
    .label {
      width: 100%;
    }
  }